import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import FeatureShowcaseSection from "./components/info/FeatureShowcaseSection";
import AutomationShowcaseMockup from "./components/info/AutomationShowcaseMockup";
import AffiliateShowcaseMockup from "./components/info/AffiliateShowcaseMockup";

const AUTOMATION_BULLETS = [
  "Connect your Instagram account and create keyword-triggered DM automations for any post.",
  "Set custom reply messages with personalization like {{name}} to feel human and on-brand.",
  "Manage all automations from one dashboard — activate, deactivate, or edit anytime.",
  "Run AI comment analysis with one click — get sentiment scores, audience persona, top themes, and key insights.",
  "Cached AI results let you revisit insights without extra cost.",
];

const AFFILIATE_BULLETS = [
  "Generate trackable affiliate links from accepted brand campaigns in seconds.",
  "Share short Infuber links (infuber.com/a/xxx) that redirect to the brand's landing page.",
  "Track total visits, unique visits, conversions, and conversion rate in real time.",
  "See device and location breakdowns to understand where your audience clicks from.",
  "Earn commissions when your audience converts through your unique links.",
];

const InstaToolInfoPage = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />

      <main>
        {/* Hero */}
        <section className="relative overflow-hidden border-b border-white/10">
          <div className="pointer-events-none absolute inset-0">
            <div className="absolute -top-40 left-1/2 h-[32rem] w-[32rem] -translate-x-1/2 rounded-full bg-orange-500/15 blur-3xl" />
            <div className="absolute -bottom-40 left-1/3 h-[30rem] w-[30rem] -translate-x-1/2 rounded-full bg-blue-500/10 blur-3xl" />
          </div>

          <div className="relative mx-auto max-w-6xl px-6 py-16 md:py-24">
            <div className="mx-auto max-w-3xl text-center">
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-orange-400">
                Insta Tools
              </p>
              <h1 className="mt-4 text-3xl font-bold text-white md:text-5xl">
                Grow faster with automation, AI insights & affiliate earnings
              </h1>
              <p className="mt-5 text-sm leading-relaxed text-white/70 md:text-lg">
                Insta Tools helps creators automate Instagram DMs, understand their audience
                with AI comment analysis, and monetize through trackable affiliate links —
                all from one dashboard.
              </p>
              <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <Link
                  to="/insta-tools/pricing"
                  className="inline-flex w-full items-center justify-center rounded-xl bg-orange-500 px-6 py-3 text-sm font-semibold text-white transition hover:bg-orange-600 sm:w-auto"
                >
                  View Pricing
                </Link>
                <Link
                  to="/influencer/login?redirectTo=/influencer/dashboard/automation-dashboard"
                  className="inline-flex w-full items-center justify-center rounded-xl border border-white/30 bg-transparent px-6 py-3 text-sm font-semibold text-white transition hover:bg-white hover:text-black sm:w-auto"
                >
                  Get Started
                </Link>
              </div>
            </div>
          </div>
        </section>

        <div className="relative mx-auto max-w-7xl px-6">
          <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
            <div className="absolute top-24 right-0 h-72 w-72 rounded-full bg-orange-500/10 blur-3xl" />
            <div className="absolute bottom-40 left-0 h-72 w-72 rounded-full bg-blue-500/10 blur-3xl" />
          </div>

          <FeatureShowcaseSection
            id="dm-automation"
            visualWide
            eyebrow="DM Automation & AI Analytics"
            title="Automate DMs and understand your audience with AI"
            description="Set up keyword-triggered Instagram automations that reply instantly — then analyze comment sentiment, engagement quality, and audience persona with built-in AI. Everything lives in one dashboard."
            bullets={AUTOMATION_BULLETS}
          >
            <AutomationShowcaseMockup />
          </FeatureShowcaseSection>

          <FeatureShowcaseSection
            id="affiliate-links"
            reverse
            visualWide
            eyebrow="Affiliate Links"
            title="Generate trackable links and earn from every conversion"
            description="Join brand campaigns, generate short affiliate links, and share them anywhere. Every click is tracked — visits, unique visitors, conversions, and conversion rate — so you know exactly what's working."
            bullets={AFFILIATE_BULLETS}
          >
            <AffiliateShowcaseMockup />
          </FeatureShowcaseSection>
        </div>

        {/* CTA */}
        <section className="relative overflow-hidden border-t border-white/10">
          <div className="pointer-events-none absolute inset-0">
            <div className="absolute -top-32 left-1/2 h-64 w-64 -translate-x-1/2 rounded-full bg-orange-500/15 blur-3xl" />
          </div>
          <div className="relative mx-auto max-w-6xl px-6 py-16 text-center">
            <h2 className="text-2xl font-bold text-white md:text-3xl">
              Ready to unlock Insta Tools?
            </h2>
            <p className="mx-auto mt-3 max-w-xl text-sm text-white/70 md:text-base">
              Start free with media dashboards. Upgrade to Premium for DM automation,
              AI analytics, and affiliate link generation.
            </p>
            <Link
              to="/insta-tools/pricing"
              className="mt-6 inline-flex items-center justify-center rounded-xl bg-orange-500 px-8 py-3 text-sm font-semibold text-white transition hover:bg-orange-600"
            >
              See Plans & Pricing
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default InstaToolInfoPage;
